const ServiceType = {
    PLAYBACK: 'playback',
    CONCURRENCY: 'concurrency',
    PRECISION: 'precision',
    RESUME_POINTS: 'resumePoints',
    USER_ACTIONS: 'userActions',
    USER_ACTIONS_WATCHED: 'userActionsWatched',
};

export default ServiceType;
